import type { RouteRecordRaw } from 'vue-router';

const ProfilePage = () => import('@/views/profile/ProfilePage.vue');
const ProfileDetailsPage = () => import('@/views/profile/details/ProfileDetails.vue');
const ProfileNotificationsPage = () => import('@/views/profile/notifications/NotificationsPage.vue');
const ProfilePaymentsPage = () => import('@/views/profile/payments/PaymentsPage.vue');
const PaymentHistoryPage = () => import('@/views/profile/payments/PaymentHistoryPage.vue');

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    children: [
      {
        path: '',
        name: 'profile-details-redirect',
        redirect: { name: 'profile-details' },
      },
      {
        path: 'details',
        name: 'profile-details',
        component: ProfileDetailsPage,
      },
      {
        path: 'notifications',
        name: 'profile-notifications',
        component: ProfileNotificationsPage,
      },
      {
        path: 'payments',
        name: 'profile-payments',
        component: ProfilePaymentsPage,
      },
    ],
  },
  {
    path: '/profile/payments/history',
    name: 'profile-payments-history',
    component: PaymentHistoryPage,
  },
];
